import React, { useEffect, useState } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import { Form, Input, notification } from 'antd';
import { AuthWrapper } from './style';
import Heading from '../../../../components/heading/heading';
import logoBalken from '../../../../static/img/balken/balken_logo_BALKEN.png';
import { Api } from '../../../../config/api/axiosInterceptors';
import { Button } from '../../../../components/buttons/buttons';
import { validatePassword, validatePasswordConfirmation } from '../../../../utils/validationRules';
import { endpointError } from '../../../../utils/utils';

function ResetPassword() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  const email = queryParams.get('email');
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {}, [token, email]);

  const handleSubmit = async (values) => {
    setLoading(true);
    const data = {
      token,
      email,
      ...values,
    };

    try {
      const response = await Api.post('/password/reset', data);
      notification.success({
        message: 'Contraseña actualizada',
        description: 'Tu contraseña ha sido actualizada exitosamente.',
      });
      form.resetFields();
    } catch (error) {
      const errorResponse = error.response?.data || {};
      notification.error({
        message: 'Error al actualizar la contraseña',
        description: endpointError(errorResponse),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthWrapper>
      <div className="auth-contents">
        <Form form={form} onFinish={handleSubmit} layout="vertical">
          <img className="balken-logo" src={logoBalken} alt="" />
          <Heading as="h3">
            <strong className="heading-title">Actualizar contraseña</strong>
            <p className="secondary-text">
              Crea una nueva contraseña para tu cuenta. Asegúrate de que sea segura y fácil de recordar.
            </p>
          </Heading>
          <Form.Item
            name="password"
            // rules={[{ message: 'Por favor introduzca su nueva contraseña', required: true }]}
            rules={validatePassword()}
            label="Contraseña"
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="password_confirmation"
            // rules={[{ message: 'Por favor introduzca la nueva contraseña!', required: true }]}
            rules={[
              { required: true, message: 'Por favor confirma tu contraseña' },
              validatePasswordConfirmation(form.getFieldValue),
            ]}
            label="Confirmar contraseña"
          >
            <Input.Password />
          </Form.Item>

          <Button block htmlType="submit" type="primary" size="large" loading={loading}>
            Actualizar contraseña
          </Button>

          <div className="action-link">
            <p className="return-text">
              Regresar a <NavLink to="/login">Iniciar sesión</NavLink>
            </p>
          </div>
        </Form>
      </div>
    </AuthWrapper>
  );
}

export default ResetPassword;
